import { LoginCard } from "@/projects/components/login-card";

export function TeacherLoginPage() {
  return <LoginCard role="teacher" />;
}
